import GetAlbumDetails from './GetAlbumDetails';
import GetArtistCollaborations from './GetArtistCollaborations';
import GetArtistDetails from './GetArtistDetails';
import GetArtistDetailsWithCollaborations from './GetArtistDetailsWithCollaborations';
import GetArtistDetailsWithCurators from './GetArtistDetailsWithCurators';
import GetComposerDetails from './GetComposerDetails';
import GetCuratorDetails from './GetCuratorDetails';
import GetGenreCurators from './GetGenreCurators';
import GetPlaylistCurator from './GetPlaylistCurator';
import GetPlaylistCurators from './GetPlaylistCurators';
import GetRecentlyPlayedSources from './GetRecentlyPlayedSources';
import GetStationCurator from './GetStationCurator';
import GetStationCurators from './GetStationCurators';

export const Templates = Object.freeze({
  GetAlbumDetails,
  GetArtistCollaborations,
  GetArtistDetails,
  GetArtistDetailsWithCollaborations,
  GetArtistDetailsWithCurators,
  GetComposerDetails,
  GetCuratorDetails,
  GetGenreCurators,
  GetPlaylistCurator,
  GetPlaylistCurators,
  GetRecentlyPlayedSources,
  GetStationCurator,
  GetStationCurators,
} as const);
